<!-- 管理费用 -->
<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar title="管理费用详情" left-text="返回" left-arrow @click-left="goback" />
      <van-grid :column-num="1" v-if="orderList.length > 0">
        <van-grid-item class="vant-grid-item_content">
          <span>{{ `订单数量: ${orderList.length}` }}</span>
          <span v-for="(item, index) in contTableDataGroupView" :key="index"
            style="margin-right: 15px; font-size: 12px; display: inline-block">
            {{
              item.installerIdStr +
              `(${item.children.length}单): ${item.totalManageFee}元;`
            }}
            <span v-if="
              contTableDataGroupTotal.length > 1 &&
              index === contTableDataGroupView.length - 1
            " style="color: #1989fa; margin-left: 10px" @click="showAll = !showAll">
              {{ showAll ? "折叠" : "...展开" }}</span>
          </span>
        </van-grid-item>
      </van-grid>
    </van-sticky>
    <MobileTablePro :columns="columns" :data="orderList" :loading="loading" :has-more="false" @load="onLoad"
      :sticky-header="stickyHeader" :show-tooltip="showTooltip">
      <template #cell-incentiveType="{ row }">
        <span>{{ row.incentiveType == 1 ? "正激励" : "负激励" }}</span>
      </template>
    </MobileTablePro>
  </div>
</template>
<script>
import { tableDataGroupAndTotal } from "@/views/settlement/columns.js";
import MobileTablePro from '@/components/MobileTablePro.vue'
export default {
  name: "InstallPage",
  components: { MobileTablePro },
  data() {
    return {
      loading: false,
      finished: false,
      orderList: [],
      contTableDataGroupTotal: [],
      showAll: false,
      columns: [
        { key: 'serialNumber', title: '序号', width: '50px', fixed: 'left' },
        { key: "brandIdStr", title: "品牌", width: "50px", fixed: "left" },
        { key: "carModelIdStr", title: "车型", width: "80px" },
        { key: "customerName", title: "客户名称", width: "60px" },
        { key: "contactInfo", title: "联系方式" },
        { key: "regionName", title: "省市区", width: "140px" },
        { key: "vin", title: "车架号", width: "80px" },
        { key: "mainOrderNo", title: "主机订单号", width: "80px" },
        { key: "upstreamOrderNo", title: "上游订单号", width: "80px" },
        { key: "installerIdStr", title: "安装师傅", width: "100px" },
        { key: "manageFee", title: "管理费用", width: "80px" },
        { key: "feeGroupIdStr", title: "所属管理费群组", width: "100px" },
      ],
      stickyHeader: true,
      showTooltip: true,
    };
  },
  computed: {
    contTableDataGroupView() {
      if (this.contTableDataGroupTotal.length <= 1) {
        return this.contTableDataGroupTotal;
      }
      return this.showAll
        ? this.contTableDataGroupTotal
        : this.contTableDataGroupTotal.slice(0, 1);
    },
  },
  methods: {
    goback() {
      //返回上一页
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = false;
      this.getPageData();
    },
    getPageData() {
      //获取分页数据
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/h5/listModuleDetail",
        method: "get",
        params: {
          id: this.$route.query.id,
          module: "settlementManageFeeList",
        },
      }).then((res) => {
        this.orderList = res.data.data.settlementManageFeeList;
        this.orderList.forEach((item, index) => {
          item.serialNumber = index + 1;
        });

        this.contTableDataGroupTotal = tableDataGroupAndTotal(
          this.orderList,
          "installerIdStr",
          "manageFee"
        );
        this.loading = false;
        this.finished = true;
      });
    },
  },
};
</script>
